export default class StateMachine {
    constructor() {
        this._forceChangeState = 0;
        this._states = new Map();
    }
    get count() {
        return this._states.size;
    }
    Add(addState) {
        if (this._states.has(addState.id)) {
            return false;
        }
        this._states.set(addState.id, addState);
        return true;
    }
    Remove(id) {
        return this._states.delete(id);
    }
    RemoveAll() {
        this._states.clear();
        this.currState = null;
    }
    ExitCurrState(param = null) {
        if (null != this.currState) {
            this.currState.OnExit(null, param);
            this.currState = null;
        }
    }
    ChangeState(id, param = null) {
        var state = this.Find(id);
        if (state != null) {
            if (null != this.currState) {
                this.currState.OnExit(state, param);
            }
            this.lastState = this.currState;
            this.currState = state;
            state.OnEnter(this.lastState, param);
            return true;
        }
        console.error("[状态机] 不存在的状态ID:" + id);
        return false;
    }
    SetForceChangeState(id, param = null) {
        this._forceChangeState = id;
        this._forceChangeParam = param;
    }
    LogicUpdate(dt) {
        if (this.currState == null) {
            if (this._forceChangeState != 0) {
                this.ChangeState(this._forceChangeState, this._forceChangeParam);
                this._forceChangeState = 0;
                this._forceChangeParam = null;
                this.OnRunning(null, dt);
            }
            return;
        }
        if (this._forceChangeState != 0) {
            this.ChangeState(this._forceChangeState, this._forceChangeParam);
            this._forceChangeState = 0;
            this._forceChangeParam = null;
            this.OnRunning(null, dt);
            return;
        }
        let nextState = this.currState.GetNextState();
        if (nextState != 0) {
            this.ChangeState(nextState);
        }
        this.OnRunning(null, dt);
    }
    OnRunning(param, dt) {
        if (null == this.currState) {
            return;
        }
        this.currState.OnRunning(param, dt);
    }
    Find(id) {
        return this._states.get(id);
    }
}
